import { memo, useState } from 'react';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';
import BinaryQuestion from '~/components/binary-question';
import { showBinaryQuestion } from '~/components/notifications/ducks/notifications.js';
import { ScrollToTopOnce as ScrollToTop } from '~/utils/scroll-to-top';
import useTranslations from '~/components/translation/use-translations';
import { LICENSE_OGA } from '~/utils/license-utils';
import { selectLicense } from '~/components/brand/ducks/selectors';
import { Box } from '@comeon/ui';
import breakpoint from '~/utils/style-utils';

const textKeys = ['LICENSE_AGE_LIMIT_TEXT', 'BUTTON_OK'];
const IconText = styled(Box)`
	align-items: center;
	background-color: var(--footer-18-icon, rgba(var(--secondary), 1));
	border-radius: 50%;
	color: var(--footer-18-icon-text, rgba(var(--base-01), 1));
	display: flex;
	font: var(${props => (props.smaller ? '--small' : '--label-regular')});
	margin-left: ${props => (props.smaller ? '12px' : props.marginL)};
	min-width: ${props => (props.smaller ? '28px' : props.size || 'var(--footer-logo-18-height, 28px)')};
	max-width: ${props => (props.smaller ? '28px' : props.size || 'var(--footer-logo-18-height, 28px)')};
	min-height: ${props => (props.smaller ? '28px' : props.size || 'var(--footer-logo-18-height, 28px)')};
	max-height: ${props => (props.smaller ? '28px' : props.size || 'var(--footer-logo-18-height, 28px)')};
	justify-content: center;
	cursor: pointer;
	${breakpoint.lg`
	margin-left: ${props => props.marginL};
		min-width: ${props => props.size || 'var(--footer-logo-18-height, 28px)'};
		max-width: ${props => props.size || 'var(--footer-logo-18-height, 28px)'};
		min-height: ${props => props.size || 'var(--footer-logo-18-height, 28px)'};
		max-height: ${props => props.size || 'var(--footer-logo-18-height, 28px)'};
		font: var(--label-regular);
  `}
`;

const StyledBinaryQuestion = styled(BinaryQuestion)`
	.binary-question__yes {
		border-left: none;
	}
`;

const IconStaticText = memo(({ item, size, smaller, marginLeft, disablePopup }) => {
	const itemName = item.name ? item.name : item.imageURL;
	const itemLink = item.url ? String(item.url) : '';
	const [openPopup, setOpenPopup] = useState(false);
	const { translations: t, isLoadingTranslations } = useTranslations(textKeys);
	const license = useSelector(selectLicense);
	const ageLimit = license === LICENSE_OGA ? 19 : 18;

	if (isLoadingTranslations) {
		return <div className="spinner" />;
	}

	const text = t[itemLink].replace('XX', ageLimit);

	return (
		<>
			<IconText marginL={marginLeft} size={size} smaller={smaller} onClick={() => setOpenPopup(true)}>
				{itemName}
			</IconText>
			{openPopup && !disablePopup && (
				<>
					<ScrollToTop behavior="smooth" />
					<StyledBinaryQuestion
						data-at={`binary-question-${itemName}`}
						shouldOpenBinary
						title={itemName}
						text={text}
						yesText={t.BUTTON_OK}
						onYesClick={() => setOpenPopup(false)}
					/>
				</>
			)}
		</>
	);
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(
		{
			showBinaryQuestion
		},
		dispatch
	)
});

export default connect(mapDispatchToProps)(IconStaticText);
